export function isStableFrame(
  frameDiff: number,
  rollingMeanDiff: number,
  diffThreshold: number,
  rollingDiffThreshold: number,
): boolean {
  return frameDiff < diffThreshold && rollingMeanDiff < rollingDiffThreshold;
}
